import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Text } from '@components'
import { BottomModalBase } from '@components'
import { useLanguage } from '@context'

type AddContactModalProps = {
  isVisible: boolean
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>
  contactName?: string
  onAddPrivate?: () => void
  onAddProfessional?: () => void
}

export const AddContactModal = ({
  isVisible,
  setIsVisible,
  contactName = '',
  onAddPrivate,
  onAddProfessional,
}: AddContactModalProps): React.ReactElement => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)

  const handleAddPrivate = () => {
    onAddPrivate?.()
    setIsVisible(false)
  }

  const handleAddProfessional = () => {
    onAddProfessional?.()
    setIsVisible(false)
  }

  return (
    <BottomModalBase isVisible={isVisible} setIsVisible={setIsVisible} wrapContent>
      <View style={styles.container}>
        <View style={styles.header}>
          <Text type="titleBold" style={styles.title}>
            {contactName ? t('addContactModal.addPerson', { name: contactName }) : t('addContactModal.addDefaultPerson')}
          </Text>
          <Text type="body" style={styles.subtitle}>
            {contactName ? t('addContactModal.addPerson', { name: contactName }) : t('addContactModal.addDefaultPerson')}
          </Text>
        </View>

        {/* Ajouter en Privé */}
        <TouchableOpacity
          style={styles.option}
          onPress={handleAddPrivate}
          activeOpacity={0.7}
        >
          <View style={[styles.optionContent, styles.primaryOptionContent]}>
            <Text type="body" color={theme.colors.primary} style={styles.optionText}>
              {t('addContactModal.addPrivate')}
            </Text>
          </View>
        </TouchableOpacity>

        {/* Ajouter en Professionnel */}
        <TouchableOpacity
          style={styles.option}
          onPress={handleAddProfessional}
          activeOpacity={0.7}
        >
          <View style={[styles.optionContent, styles.secondaryOptionContent]}>
            <Text type="body" color={theme.colors.green} style={styles.optionText}>
              {t('addContactModal.addProfessional')}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    </BottomModalBase>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      width: '100%',
      paddingVertical: theme.spacing.lg,
      alignItems: 'center',
    },
    header: {
      width: '100%',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.xl,
      marginBottom: theme.spacing.xl,
    },
    title: {
      textAlign: 'center',
      color: theme.colors.black,
      marginBottom: theme.spacing.sm,
    },
    subtitle: {
      textAlign: 'center',
      color: theme.colors.greyBlue,
      fontSize: 14,
    },
    option: {
      width: '100%',
      marginBottom: theme.spacing.md,
      paddingHorizontal: theme.spacing.xl,
    },
    optionContent: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.border.jumbo,
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      borderWidth: 1,
      borderColor: theme.colors.lightGrey,
      shadowColor: theme.colors.black,
      backgroundColor: theme.colors.white,
    },
    primaryOptionContent: {
      borderColor: theme.colors.primary,
    },
    secondaryOptionContent: {
      borderColor: theme.colors.green,
    },
    optionText: {
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
    },
  }) 